<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      v-if="showForm.basic"
      :close-on-click-modal="false"
      title="广告详情"
      width="500"
      @close="close"
    >
      <el-row>
        <el-col :span="5">标题:</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">视频地址:</el-col>
        <el-col :span="19">
          {{ showForm.basic.videoUrl }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">视频时长:</el-col>
        <el-col :span="19">
          {{ showForm.basic.videoDuration }}秒
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">可用时长:</el-col>
        <el-col :span="19">
          {{ showForm.basic.duration }}分钟
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">展示次数:</el-col>
        <el-col :span="19">
          {{ showForm.basic.totalVisitCount }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">观看次数:</el-col>
        <el-col :span="19">
          {{ showForm.basic.totalRecordCount }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">备注:</el-col>
        <el-col :span="19">
          {{ showForm.basic.text || '无' }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">状态:</el-col>
        <el-col :span="19">
          <el-tag v-if="showForm.step === 1">待发布</el-tag>
          <el-tag v-if="showForm.step === 2" type="success">已发布</el-tag>
          <el-tag v-if="showForm.step === 3" type="danger">已下架</el-tag>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">创建时间:</el-col>
        <el-col :span="19">
          {{ moment(showForm.created).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">修改时间:</el-col>
        <el-col :span="19">
          {{ showForm.updated && moment(showForm.updated).format('YYYY-MM-DD HH:mm:ss') || '无' }}
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { findAdvertise } from '@/api/alfmeier'
export default {
  name: 'AlfmeierAdvertiseDetail',
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      showForm: {},
      row: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const advertiseId = row.advertiseId
      this.row = row
      const data = await findAdvertise({
        advertiseId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
